import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./styles";
import { ErrorMessage } from "../error-message";
// eslint-disable-next-line import/no-unresolved
import DropdownChevron from "../../assets/dropdown-chevron-closed.svg?inline";

export const Select = ({
  items,
  onItemClick,
  initialValue,
  classname,
  ariaLabel,
  disabled,
  errorMessage,
  id,
  hasError,
}) => {
  return (
    <>
      <select
        style={{
          backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
            DropdownChevron
          )}")`,
        }}
        className={classnames(
          styles.select,
          classname,
          hasError && styles.inputError
        )}
        onChange={(event) => {
          onItemClick && onItemClick(event);
        }}
        aria-label={ariaLabel}
        disabled={disabled}
        value={initialValue}
        autoComplete="off"
        id={id}
      >
        {items &&
          items.map((item) => (
            <option
              key={item.value}
              value={item.value}
              disabled={item.disabled}
            >
              {item.text}
            </option>
          ))}
      </select>
      {hasError && errorMessage && <ErrorMessage message={errorMessage} />}
    </>
  );
};

Select.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }).isRequired
  ).isRequired,
  onItemClick: PropTypes.func,
  initialValue: PropTypes.string,
  classname: PropTypes.string,
  ariaLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
};

Select.defaultProps = {
  initialValue: "",
  errorMessage: "",
  id: "",
  hasError: false,
};
